<template>
  <div class="member-stat-list" style="padding:16px;">
    <table class="students-table" id="students-activity-table">
      <caption>
        {{
          $t("student.member activity")
        }}
      </caption>
      <thead>
        <tr>
          <th scope="col">{{ $t("student.name") }}</th>
          <th scope="col">{{ $t("student.last_cardview") }}</th>
          <th scope="col">{{ $t("student.last_quiz") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="{ id, name, username, last_cardview, last_quiz } in students"
          :key="`activity-${id}`"
        >
          <td>{{ name ? name : "'" + username + "'" }}</td>
          <td>
            {{ formatFromNow(last_cardview) }}
            <van-button
              v-if="!!last_cardview"
              :to="{
                name: 'student-practice-history',
                params: { classroom_id: classroom, student_id: id }
              }"
            >
              <span
                ><i class="fas fa-history" /> {{ $t("stats.history") }}</span
              >
            </van-button>
          </td>
          <td>
            {{ formatFromNow(last_quiz) }}
            <van-button
              v-if="!!last_quiz"
              :to="{
                name: 'student-quiz-history',
                params: { classroom_id: classroom, student_id: id }
              }"
            >
              <span
                ><i class="fas fa-history" /> {{ $t("stats.history") }}</span
              >
            </van-button>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="students-table" id="students-placement-table">
      <caption>
        {{
          $t("student.member placementtest")
        }}
      </caption>
      <thead>
        <tr>
          <th scope="col">{{ $t("student.name") }}</th>
          <th scope="col">{{ $t("student.last_placementtest") }}</th>
          <th scope="col">{{ $t("student.best_placementtest") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="{
            id,
            name,
            username,
            last_placementtest,
            best_placement_level,
            best_placement_score
          } in students"
          :key="`placements-${id}`"
        >
          <td>{{ name ? name : "'" + username + "'" }}</td>
          <td>
            {{ formatFromNow(last_placementtest) }}
            <van-button
              class="stats-btn stats-cardview"
              v-if="!!last_placementtest"
              :to="{
                name: 'student-placementtest-history',
                params: { classroom_id: classroom, student_id: id }
              }"
            >
              <span
                ><i class="fas fa-history" /> {{ $t("stats.history") }}</span
              >
            </van-button>
          </td>
          <td v-if="last_placementtest">
            {{ best_placement_level }}:
            {{ parseFloat(best_placement_score).toFixed(2) }}%
          </td>
          <td v-else>-</td>
        </tr>
      </tbody>
    </table>

    <h3>{{ $t("notes") }}</h3>
    <div
      v-for="{ id, user, box_name, data } in boxStateStats"
      :key="`note-practice-${id}`"
    >
      <h5>
        {{ user.name }} - {{ user.email }} {{ $t("practiced") }}
        {{ box_name }} x {{ data ? data.box_seen_count : 1 }}
      </h5>
    </div>
    <div v-for="{ id, user, data } in quizResultStats" :key="`note-quiz-${id}`">
      <h5>
        {{ user.name }} - {{ user.email }} {{ $t("got") }}
        {{ parseFloat(data.score).toFixed(2) }}%
      </h5>
    </div>
  </div>
</template>

<script>
import formatTS from "@/mixins/momentMixin";

export default {
  name: "MembersStatList",
  mixins: [formatTS],
  props: {
    boxStateStats: {
      type: Array
    },
    quizResultStats: {
      type: Array
    },
    students: {
      type: Array,
      required: true
    },
    classroom: { type: Number, required: true }
  }
};
</script>

<style lang="scss">
.students-table {
  min-width: 90%;
  margin: 0 auto 4.5rem;
  border-collapse: collapse;
  caption {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
  }
  thead th {
    border-bottom: gray 1px solid;
    padding-bottom: 0.5rem;
  }
  tbody td {
    padding-top: 0.35rem;
  }
  td {
    text-align: center;
  }
}
</style>
